import * as React from 'react';
import { Translate } from "react-localize-redux";
import Routes from 'src/core/Routes';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { Row, Col, Form } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { GenericFormItem } from "src/utils/FormUtil";
import { FormComponentProps } from "antd/lib/form";
// import FormTestForm, { UpdateThingDTO } from "src/pages/examples/FormTestForm";
import FormTestSimpleForm, { UpdateThingDTO } from "src/pages/examples/FormTestSimpleForm";

interface FormTestProps extends PageProps<{}>, FormComponentProps {
}

interface FormTestState {
}

class FormTest extends React.Component<FormTestProps, FormTestState> {
    constructor(props: FormTestProps) {
        super(props);
        bindAllOfThis(this, FormTest.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    onSubmit(values: UpdateThingDTO) {

        console.warn("Form Submitted!", values); // JB - Remove this console.warn
    }

    render() {
        // let values = {
        //     username: "potato",
        //     password: "pass",
        //     subMember: {
        //         name: "blah blah blah",
        //         value: "Nope!",
        //     },
        //     isActive: false
        // } as UpdateThingDTO;
        let values = {
            username: "potato",
            password: "pass",
            isActive: false,
            age: 25,
        } as UpdateThingDTO;

        return <div>
            <div>Just Showing the things</div>

            {/* <FormTestForm values={values} onSubmit={this.onSubmit} /> */}
            <FormTestSimpleForm values={values} onSubmit={this.onSubmit} />
        </div>;
    }
}

export default FormTest;



// WEBPACK FOOTER //
// ./src/pages/examples/FormTest.tsx